import React from "react";
import "./Activity_tabs.css";
import { Link } from "react-router-dom";

function Activity_tabs() {
  return (
    <>
      <section className="Activity_tabs">
        <div className="Activity_tabs_cards">
          <Link to={"/invitation-bonus"}>
            <div className="small_card">
              <div>
                <div className="icon_box ">
                  <img
                    src={"/assets/images/activity/Activity_tabs/user.png"}
                    alt="invitation"
                    className="icon_img"
                  />
                </div>
              </div>
              <span>Invitation Bonus</span>
              <span className="arrow">›</span>
            </div>
          </Link>
          <Link to={"/betting-rebate"}>
            <div className="small_card">
              <div>
                <div className="icon_box ">
                  <img
                    src={"/assets/images/activity/Activity_tabs/wallet.png"}
                    alt="invitation"
                    className="icon_img"
                  />
                </div>
              </div>
              <span>Invitation Bonus</span>
              <span className="arrow">›</span>
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}

export default Activity_tabs;
